import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerWordGroupsTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution } from "./solution";
import type {
  WordGroupsDefinition,
  WordGroupsProgress,
  WordGroupsSolution,
  WordGroupsSubmission,
} from "./types";

registerWordGroupsTranslations(i18n);

/**
 * No `localFeedback`: nothing can be said of a proposal without the key, which stays on the
 * server. `applyVerdict` makes the server's reading of every proposal part of the autosaved
 * progress (ADR 0041, 0059).
 */
export const wordGroupsModule: PuzzleTypeModule<
  WordGroupsDefinition,
  WordGroupsSubmission,
  WordGroupsProgress,
  WordGroupsSolution
> = {
  key: "word_groups",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
